export class CordovaUtils {

   static async openCamera() {
       const n1 = navigator as unknown as {
            camera: {
                getPicture:
                    (onSuccess: (s: string) => void, onFail: (e: string) => void, o:
                        { quality: number; destinationType: number }) => void;
            };
        }
        return new Promise((resolve, reject) => {
            n1.camera.getPicture((s) => {
                resolve(s)
            }, (e) => reject(e), {quality: 50, destinationType: 0})

        });
    }

   // static  async onSuccess(imageURI: string) {
   //      const  ele = document.getElementById('myImage');
   //      (ele as HTMLEmbedElement).src = imageURI;
   //      console.log(ele)
   //  }
   //
   //
   //
   //
   //  onFail(message: string) {
   //      alert('Failed because: ' + message);
   //  }
    static async camera(){
       const win: any = window;
       const camera = win.camera();
       camera.getPicture((s: string)=>{
            return s;
       })
    }

    static async openGaoDei() {
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            "uri": "amapuri://route/plan/",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
}
